module.exports = __webpack_public_path__ + "img/new-icon.d68110fc.gif";